<template>
    <v-select 
        :multiple="multiple" 
        :filterable="true" 
        :options="options" 
        v-model="selected" 
        :placeholder="placeholder"
        :clearable="false"
    />
</template>

<script>
import vSelect from "vue-select";
export default {
    components: {
        vSelect,
    },
    props: {
        multiple: {
            type: Boolean,
            default: false,
        },
        draw: {
            type: Number,
        },
        placeholder: {
            type: String
        },
        value: {
            type: Object
        },
        sourceWarehouseId: {
            type: Number,
        },
        useType: {
            type: String
        }
    },
    data() {
        return {
            baseUrl: "/api/wms/v1/outbound/simple-sto/dest-warehouse-options",
            options: [],
            selected: (this.multiple) ? [] : null
        };
    },
    methods: {
        get() {
            if (this.selected != null) {
                if (this.sourceWarehouseId == this.selected.id) {
                    this.selected = null
                }
            }

            this.$http.get(this.baseUrl, {
                params: {
                    src_warehouse_id: this.sourceWarehouseId,
                }
            })
            .then(resp => {
                if (resp.code == 200) {
                    this.options = []
                    if (resp.data.records) {
                        if (this.useType == "filter") {
                            this.options.push({ id: 0, label: 'All' });
                            this.options.push(...resp.data.records);
                        } else {
                            this.options = resp.data.records;
                        }
                    } else {
                        this.options = []
                    }
                } else {
                    this.options = []
                    console.log(resp.data);
                }
            })
            .catch(error => {
                console.log(error)
            });
        }
    },
    watch: {
        selected(v) {
            this.selected = v;
            this.$emit("selected", v);
        },
        value(v) {
            if (v) {
                this.selected = v
            }
        },
        sourceWarehouseId(val) {
            if (val) {
                this.get();
            }
        },
        useType(val) {
            if (val) {
                console.log("watcher dest warehouse => ", val)
            }
        }
    },
    mounted() {
        this.get();
    }
};
</script>